import { makeRequest } from '../utils/apiUtils';

export const GET_LOST_ORDERS = 'lostOrders/GET_LOST_ORDERS';
export const GET_LOST_ORDERS_SUCCESS = 'lostOrders/GET_LOST_ORDERS_SUCCESS';
export const GET_LOST_ORDERS_FAIL = 'lostOrders/GET_LOST_ORDERS_FAIL';

export const GET_LOST_ORDERS_STATUSES = 'lostOrders/GET_LOST_ORDERS_STATUSES';
export const GET_LOST_ORDERS_STATUSES_SUCCESS = 'lostOrders/GET_LOST_ORDERS_STATUSES_SUCCESS';
export const GET_LOST_ORDERS_STATUSES_FAIL = 'lostOrders/GET_LOST_ORDERS_STATUSES_FAIL';

export const SAVE_LOST_ORDER = 'lostOrders/SAVE_LOST_ORDER';
export const SAVE_LOST_ORDER_SUCCESS = 'lostOrders/SAVE_LOST_ORDER_SUCCESS';
export const SAVE_LOST_ORDER_FAIL = 'lostOrders/SAVE_LOST_ORDER_FAIL';

export const DELETE_LOST_ORDER = 'lostOrders/DELETE_LOST_ORDER';
export const DELETE_LOST_ORDER_SUCCESS = 'lostOrders/DELETE_LOST_ORDER_SUCCESS';
export const DELETE_LOST_ORDER_FAIL = 'lostOrders/DELETE_LOST_ORDER_FAIL';

export const SET_EDIT_FORM = 'lostOrders/SET_EDIT_FORM';
export const SET_EDIT_FORM_ERRORS = 'lostOrders/SET_EDIT_FORM_ERRORS';
export const CLEAR_EDIT_FORM = 'lostOrders/CLEAR_EDIT_FORM';

export function getLostOrders(query, id = '') {
  const queryString = Object.keys(query).map(key => `${key}=${encodeURIComponent(query[key])}`).join('&');
  if (id) {
    id = `/${id}`;
  }
  return makeRequest(`/saduka/lostOrders${id}?${queryString}`, {
    types: [GET_LOST_ORDERS, GET_LOST_ORDERS_SUCCESS, GET_LOST_ORDERS_FAIL],
    options: {
      credentials: 'include'
    },
    id
  });
}

export function getLostOrdersStatuses() {
  return makeRequest(`/saduka/lostOrderStatuses`, {
    types: [GET_LOST_ORDERS_STATUSES, GET_LOST_ORDERS_STATUSES_SUCCESS, GET_LOST_ORDERS_STATUSES_FAIL],
    options: {
      credentials: 'include'
    }
  });
}

export function saveLostOrder(form, id = '') {
  const idUrl = id ? `/${id}` : '';
  return makeRequest(`/saduka/lostOrders${idUrl}`, {
    types: [SAVE_LOST_ORDER, SAVE_LOST_ORDER_SUCCESS, SAVE_LOST_ORDER_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: id ? 'PATCH' : 'POST',
      body: JSON.stringify({lostOrder: form})
    },
    form,
    isNew: !id
  })
}

export function deleteLostOrder(id) {
  return makeRequest(`/saduka/lostOrders/${id}`, {
    types: [DELETE_LOST_ORDER, DELETE_LOST_ORDER_SUCCESS, DELETE_LOST_ORDER_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'DELETE',
    },
    id
  })
}

export function setEditForm(form) {
  return {
    type: SET_EDIT_FORM,
    form
  }
}

export function setEditFormErrors(form) {
  return {
    type: SET_EDIT_FORM_ERRORS,
    form
  }
}


export function clearEditForm() {
  return {
    type: CLEAR_EDIT_FORM,
  }
}
